<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(fixFee)="data">
        {{ Number(data.item.fixFee).toFixed(2) }}
      </template>
      <template v-slot:cell(zcCode)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.zcCode)">{{ data.item.zcCode }}</div>
      </template>
      <template v-slot:cell(zcClassName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.zcClassName)">{{ data.item.zcClassName }}</div>
      </template>
      <template v-slot:cell(zcName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.zcName)">{{ data.item.zcName }}</div>
      </template>
      <template v-slot:cell(fixItem)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.fixItem)">{{ data.item.fixItem }}</div>
      </template>
      <template v-slot:cell(fixUnit)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.fixUnit)">{{ data.item.fixUnit }}</div>
      </template>
      <template v-slot:cell(changePart)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.changePart)">{{ data.item.changePart }}</div>
      </template>
      <template v-slot:cell(changePartLocation)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.changePartLocation)">{{ data.item.changePartLocation }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "hqglLogisticsFixAttachDetail",
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'zcCode', label: '实物资产编号', width: '120px'},
        {key: 'zcClassName', label: '资产类别', width: '120px'},
        {key: 'zcName', label: '资产名称', width: '120px'},
        {key: 'fixTypeLabel', label: '修理性质', width: '120px'},
        {key: 'fixExpenses', label: '修理金额（元）', width: '120px'},
        {key: 'fixDate', label: '修理日期', width: '120px'},
        {key: 'fixUnit', label: '修理单位名称', width: '120px'},
        {key: 'fixLinkPerson', label: '联系人', width: '120px'},
        {key: 'fixLinkTell', label: '联系方式', width: '120px'},
        {key: 'fixItem', label: '修理项目详情', width: '120px'},
        {key: 'changePart', label: '更换后零部件', width: '120px'},
        {key: 'changePartLocation', label: '零部件存放地点', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum2(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(0, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum3(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(4, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
